/* eslint-disable no-plusplus */
import propTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-translate';
import { Button, Container, Dropdown, Grid, Icon, Image, Input, Label, Segment } from 'semantic-ui-react';
import ribbonOrange from '../../../assets/img/ribbon-orange.png';
import envList from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import API from '../../../services/Api';
import PDFService, { PageType } from '../../../services/PDFService';
import RtMaxService from '../../../services/rtMaxService';
import RtPlusService from '../../../services/rtPlusService';
import StandardService from '../../../services/StandardService';
import { history as historyType, location as locationType, match as matchType } from '../../../utils';
import HeaderComponent from '../../shared/HeaderComponent';
import JobList from '../projet/jobList';
import productInfos from '../projet/productInfos';
import './CompareComponent.css';

class CompareComponent extends Component {
  constructor(props) {
    super(props);
    const { match: { params: { env } } } = props;
    this.state = {
      standard: {
        tarifMoStandard: productInfos[env].formula.standard.tarifMo,
      },
      rtMax: productInfos[env].formula.rtMax ? {
        tarifMoRtmax: productInfos[env].formula.rtMax.tarifMo,
      } : undefined,
      rtPlus: {
        tarifMoRtplus: productInfos[env].formula.rtPlus.tarifMo,
      },
      litleScreen: false,
    };

    // Initial State
    this.state.loading = false;

    // Filling with history info
    if (props.location && props.location.state) {
      this.state = Object.assign(this.state, props.location.state);
    }

    const {
      isoValue,
      standard: {
        tarifMoStandard,
        hourStandard,
      },
      rtMax,
    } = this.state;

    if (envList.isCP(env)) {
      this.state.standard.hourStandard = productInfos[env].formula.standard.hourNeeded;
      this.state.rtMax.hourRtmax = productInfos[env].formula.rtMax.hourNeeded;
      this.state.rtPlus.hourRtplus = productInfos[env].formula.rtPlus.hourNeeded;
    } else {
      this.state.standard.hourStandard = (
        isoValue * productInfos[env].formula.standard.hourNeeded
      ) / 100;
      if (rtMax) {
        this.state.rtMax.hourRtmax = (isoValue * productInfos[env].formula.rtMax.hourNeeded) / 100;
      }
      this.state.rtPlus.hourRtplus = (isoValue * productInfos[env].formula.rtPlus.hourNeeded) / 100;
      this.state.standard.prixMoStandardTotal = tarifMoStandard * hourStandard;
    }

    this.state.priceMoAumcarré = (tarifMoStandard * hourStandard) / isoValue;

    this.changeEntreChevronsRtmaxCompare = this.changeEntreChevronsRtmaxCompare.bind(this);
    this.changeEntreChevronsRtPlusCompare = this.changeEntreChevronsRtPlusCompare.bind(this);
    this.changeEntreChevronsStandardCompare = this.changeEntreChevronsStandardCompare.bind(this);
    this.changeTarifMoRtmax = this.changeTarifMoRtmax.bind(this);
    this.changeTarifMoRtPlus = this.changeTarifMoRtPlus.bind(this);
    this.changeTarifMoStandard = this.changeTarifMoStandard.bind(this);

    // Calculation
    this.calculatetarifRtmaxMo = this.calculatetarifRtmaxMo.bind(this);
    this.calculateTarifRtplusMo = this.calculateTarifRtplusMo.bind(this);
    this.calculatetarifStandardMo = this.calculatetarifStandardMo.bind(this);
    this.calculateTotalRtMax = this.calculateTotalRtMax.bind(this);
    this.calculateTotalRtplus = this.calculateTotalRtplus.bind(this);
    this.calculateTotalStandard = this.calculateTotalStandard.bind(this);
    this.checkConformityCPT = this.checkConformityCPT.bind(this);
    this.checkConformityRtmaxCPT = this.checkConformityRtmaxCPT.bind(this);
    this.checkConformityRtplusCPT = this.checkConformityRtplusCPT.bind(this);
    this.handleClickCompare = this.handleClickCompare.bind(this);
  }

  componentDidMount() {
    const { match: { params: { env } } } = this.props;
    const {
      epaisseurChevron,
      isoValue,
      resValue,
      rtMax,
      rtPlus,
      showMonocouche,
      standard,
    } = this.state;
    Promise.all([
      API.getPreselect(resValue, showMonocouche, epaisseurChevron),
      API.getProducts(),
    ]).then(([{ data: { preselect } }, res]) => {
      this.setState({
        standard: {
          ...standard,
          ...StandardService.getProducts(env, preselect, res, isoValue),
        },
        rtMax: {
          ...rtMax,
          ...RtMaxService.getProducts(res, preselect, isoValue, env),
        },
        rtPlus: {
          ...rtPlus,
          ...RtPlusService.getProducts(res, preselect, isoValue, env, resValue),
        },
      }, () => {
        this.calculateTotalRtMax();
        this.calculateTotalStandard();
        this.calculateTotalRtplus();
        this.calculatetarifRtmaxMo();
        this.calculatetarifStandardMo();
        this.calculateTarifRtplusMo();
        this.checkConformityCPT();
        this.checkConformityRtmaxCPT();
        this.checkConformityRtplusCPT();
      });
    });

    window.scrollTo(0, 0);
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  resize = () => {
    this.setState({ litleScreen: window.innerWidth >= 650 });
  }

  getJob = () => {
    const token = sessionStorage.getItem('USER_TOKEN');
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const tmp = JSON.parse(window.atob(base64));
      return tmp.job;
    }

    return JobList.USER;
  };

  checkConformityRtmaxCPT() {
    const {
      rtMax: {
        entreChevronsItem,
        sousChevronsItem,
      },
      showMonocouche,
    } = this.state;

    const conformityRtmax = (
      showMonocouche
      || (
        entreChevronsItem && (entreChevronsItem.cpt === 'OUI' || entreChevronsItem.cpt === '1')
      )
    )
      && sousChevronsItem && (sousChevronsItem.cpt === 'OUI' || sousChevronsItem.cpt === '1');

    this.setState({
      conformityRtmax,
    });
  }

  checkConformityRtplusCPT() {
    const {
      rtPlus: {
        entreChevronsItem,
        sousChevronsItem,
      },
      showMonocouche,
    } = this.state;

    const conformityRtplus = (
      showMonocouche
      || (
        entreChevronsItem
        && (entreChevronsItem.cpt === 'OUI' || entreChevronsItem.cpt === '1')
      )
    )
      && sousChevronsItem
      && (sousChevronsItem.cpt === 'OUI' || sousChevronsItem.cpt === '1');

    this.setState({
      conformityRtplus,
    });
  }

  calculateResistanceStandard() {
    const {
      standard,
      standard: {
        sousChevronsRes,
        entreChevronsRes,
      },
      showMonocouche,
    } = this.state;

    const thermalValue = ((!showMonocouche && Number(sousChevronsRes)) || 0)
      + Number(entreChevronsRes);
    standard.thermalValue = thermalValue;

    this.setState({
      standard,
    });
  }

  calculateResistanceRtmax() {
    const {
      rtMax,
      rtMax: {
        sousChevronsRes,
        entreChevronsRes,
      },
    } = this.state;

    rtMax.thermalValueRtmax = (
      Number(sousChevronsRes)
      + Number(entreChevronsRes)
    ).toFixed(2);

    this.setState({
      rtMax,
    });
  }

  calculateResistanceRtplus() {
    const {
      rtPlus,
      rtPlus: {
        sousChevronsRes,
        entreChevronsRes,
      },
    } = this.state;

    rtPlus.thermalValueRtplus = (
      Number(sousChevronsRes)
      + Number(entreChevronsRes)
    ).toFixed(2);

    this.setState({
      rtPlus,
    });
  }

  changeSuspentesOptionsRtmax() {
    const { arraySousChevronsRtmax, arrayEntreChevronsRtmax, rtMax } = this.state;
    const tab1 = arrayEntreChevronsRtmax || [];
    const tab2 = arraySousChevronsRtmax || [];
    rtMax.tabSuspentesRtmax = tab1.concat(tab2 || []);
    const idPositions = rtMax.tabSuspentesRtmax.map(el => el.key);
    const newPayload = rtMax.tabSuspentesRtmax.filter(
      (item, pos) => idPositions.indexOf(item.key) === pos
    );
    rtMax.tabSuspentesRtmax = newPayload;
    if (rtMax.tabSuspentesRtmax.length > 0) {
      rtMax.suspentesItemRtmax = rtMax.tabSuspentesRtmax[0].value;
      rtMax.suspentesPriceRtmax = rtMax.suspentesItemRtmax.price;
      this.setState(
        {
          rtMax,
        },
        () => this.calculateSuspentesRtmax()
      );
      return;
    }
    this.setState({
      rtMax,
    });
  }

  changeSuspentesOptionsRtplus() {
    const { arrayEntreChevrons, arraySousChevrons, rtPlus } = this.state;
    const tab1 = arrayEntreChevrons || [];
    const tab2 = arraySousChevrons || [];
    rtPlus.tabSuspentes = tab1.concat(tab2 || []);
    const idPositions = rtPlus.tabSuspentes.map(el => el.key);
    const newPayload = rtPlus.tabSuspentes.filter(
      (item, pos) => idPositions.indexOf(item.key) === pos
    );

    rtPlus.tabSuspentes = newPayload;

    if (rtPlus.tabSuspentes.length > 0) {
      rtPlus.suspentesItemRtplus = rtPlus.tabSuspentes[0].value;
      rtPlus.suspentesPriceRtplus = rtPlus.suspentesItemRtplus.price;
      this.setState(
        {
          rtPlus,
        },
        () => this.calculateSuspentesRtplus()
      );
      return;
    }
    this.setState({
      rtPlus,
    });
  }

  calculateSuspentesRtmax() {
    const {
      rtMax,
      rtMax: {
        suspentesQuantityRtmax,
        suspentesPriceRtmax,
      },
    } = this.state;

    rtMax.tarifDeSurfaceRtmax = suspentesQuantityRtmax * suspentesPriceRtmax;

    this.setState(
      {
        rtMax,
      },
      () => this.calculateTotalRtMax()
    );
  }

  calculateSuspentesRtplus() {
    const {
      rtPlus,
      rtPlus: {
        suspentesQuantityRtplus,
        suspentesPriceRtplus,
      },
    } = this.state;

    rtPlus.tarifDeSurfaceRtplus = suspentesQuantityRtplus * suspentesPriceRtplus;

    this.setState(
      {
        rtPlus,
      },
      () => this.calculateTotalRtplus()
    );
  }

  changeEntreChevronsStandardCompare(_, val) {
    const { standard } = this.state;
    if (val === null || val === undefined) return;

    const entreChevronsItem = val.value;
    standard.entreChevronsItem = entreChevronsItem;
    standard.entreChevronsPriceBrut = entreChevronsItem.price;
    standard.entreChevronsRes = entreChevronsItem.resistance;
    standard.entreChevronsCpt = entreChevronsItem.cpt;
    this.setState(
      {
        standard,
      },
      () => {
        this.calculateResistanceStandard();
        this.checkConformityCPT();
        this.calculateTotalStandard();
      }
    );
  }

  changeEntreChevronsRtmaxCompare(_, val) {
    if (val === null || val === undefined) return;
    const {
      rtMax,
      rtMax: {
        suspentesOptions,
      },
    } = this.state;

    const entreChevronsItemRtmax = val.value;
    const tabSuspentesEntre = [];
    API.getRelProduct(entreChevronsItemRtmax.id).then((res) => {
      const entreChevronsRel = res.data.relproductsproducts;
      entreChevronsRel.forEach((element) => {
        if (element.products_id_master === entreChevronsItemRtmax.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptions.length && !found) {
            if (
              suspentesOptions[i].key === element.products_id_remote
            ) {
              found = true;
              tabSuspentesEntre.push(suspentesOptions[i]);
            }
            i++;
          }
        }
      });
      const arrayEntreChevronsRtmax = tabSuspentesEntre.filter(
        x => x.value.workstype.indexOf('2') > -1
      );
      this.setState(
        {
          arrayEntreChevronsRtmax,
        },
        () => this.changeSuspentesOptionsRtmax()
      );
    });

    rtMax.entreChevronsItemR = entreChevronsItemRtmax;
    rtMax.entreChevronsPrice = entreChevronsItemRtmax.price;
    rtMax.entreChevronsRes = entreChevronsItemRtmax.resistance;
    rtMax.entreChevronsCpt = entreChevronsItemRtmax.cpt;

    this.setState(
      {
        rtMax,
      },
      () => {
        this.calculateResistanceRtmax();
        this.checkConformityRtmaxCPT();
        this.calculateTotalRtMax();
      }
    );
  }

  changeEntreChevronsRtPlusCompare(_, val) {
    if (val === null || val === undefined) return;
    const {
      rtPlus,
      rtPlus: {
        suspentesOptions,
      },
    } = this.state;

    rtPlus.entreChevronsItemRtplus = val.value;
    const tabSuspentesEntre = [];
    API.getRelProduct(rtPlus.entreChevronsItemRtplus.id).then((res) => {
      const entreChevronsRel = res.data.relproductsproducts;
      entreChevronsRel.forEach((element) => {
        if (element.products_id_master === rtPlus.entreChevronsItemRtplus.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptions.length && !found) {
            if (
              suspentesOptions[i].key === element.products_id_remote
            ) {
              found = true;
              tabSuspentesEntre.push(suspentesOptions[i]);
            }
            i++;
          }
        }
      });

      rtPlus.arrayEntreChevronsRtplus = tabSuspentesEntre.filter(
        x => x.value.workstype.indexOf('3') > -1
      );

      this.setState(
        {
          rtPlus,
        },
        () => this.changeSuspentesOptionsRtplus()
      );
    });

    rtPlus.entreChevronsPriceRtplus = rtPlus.entreChevronsItemRtplus.price;
    rtPlus.entreChevronsResRtplus = rtPlus.entreChevronsItemRtplus.resistance;
    rtPlus.entreChevronsRtplusCpt = rtPlus.entreChevronsItemRtplus.cpt;

    this.setState(
      {
        rtPlus,
      },
      () => {
        this.calculateResistanceRtplus();
        this.calculateTotalRtplus();
      }
    );
  }

  changeSousChevronsStandardCompare(_, val) {
    const { standard } = this.state;
    if (val === null || val === undefined) return;

    const sousChevronsItem = val.value;
    standard.sousChevronsItem = sousChevronsItem;
    standard.sousChevronsPriceBrut = sousChevronsItem.price;
    standard.sousChevronsRes = sousChevronsItem.resistance;
    standard.sousChevronsCpt = sousChevronsItem.cpt;
    this.setState(
      {
        standard,
      },
      () => {
        this.calculateResistanceStandard();
        this.checkConformityCPT();
        this.calculateTotalStandard();
      }
    );
  }

  changeSousChevronsRtmaxCompare(_, val) {
    const { rtMax } = this.state;
    if (val === null || val === undefined) return;

    const sousChevronsItemRtmax = val.value;
    rtMax.sousChevronsItem = sousChevronsItemRtmax;
    rtMax.sousChevronsPrice = sousChevronsItemRtmax.price;
    rtMax.sousChevronsRes = sousChevronsItemRtmax.resistance;
    rtMax.sousChevronsCpt = sousChevronsItemRtmax.cpt;
    this.setState(
      {
        rtMax,
      },
      () => {
        this.calculateResistanceRtmax();
        this.checkConformityRtmaxCPT();
        this.calculateTotalRtMax();
      }
    );
  }

  changeSousChevronsRtPlusCompare(_, val) {
    if (val === null || val === undefined) return;

    const {
      rtPlus,
      rtPlus: {
        suspentesOptions,
      },
    } = this.state;
    rtPlus.sousChevronsItemRtplus = val.value;
    const tabSuspentesSous = [];

    API.getRelProduct(rtPlus.sousChevronsItemRtplus.id).then((res) => {
      const sousChevronsRel = res.data.relproductsproducts;
      sousChevronsRel.forEach((element) => {
        if (element.products_id_master === rtPlus.sousChevronsItemRtplus.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptions.length && !found) {
            if (
              suspentesOptions[i].key === element.products_id_remote
            ) {
              found = true;
              tabSuspentesSous.push(suspentesOptions[i]);
            }
            i += 1;
          }
        }
      });
      rtPlus.arraySousChevrons = tabSuspentesSous.filter(
        x => x.value.workstype.indexOf('3') > -1
      );
      this.setState(
        {
          rtPlus,
        },
        () => {
          this.changeSuspentesOptionsRtplus();
        }
      );
    });

    rtPlus.sousChevronsPriceRtplus = rtPlus.sousChevronsItemRtplus.price;
    rtPlus.sousChevronsResRtplus = rtPlus.sousChevronsItemRtplus.resistance;
    rtPlus.sousChevronsRtplusCpt = rtPlus.sousChevronsItemRtplus.cpt;

    this.setState(
      {
        rtPlus,
      },
      () => {
        this.calculateResistanceRtplus();
        this.checkConformityRtplusCPT();
        this.calculateTotalRtplus();
      }
    );
  }

  changeTarifMoStandard(_, val) {
    const { standard } = this.state;
    standard.tarifMoStandard = val.value;
    this.setState(
      {
        standard,
      },
      () => this.calculatetarifStandardMo()
    );
  }

  changeTarifMoRtmax(_, val) {
    const { rtMax } = this.state;
    rtMax.tarifMoRtmax = val.value;
    this.setState(
      {
        rtMax,
      },
      () => this.calculatetarifRtmaxMo()
    );
  }

  changeTarifMoRtPlus(_, val) {
    const { rtPlus } = this.state;
    rtPlus.tarifMoRtplus = val.value;
    this.setState(
      {
        rtPlus,
      },
      () => this.calculateTarifRtplusMo()
    );
  }

  changeHourStandard(_, val) {
    const { standard } = this.state;
    standard.hourStandard = val.value;
    this.setState(
      {
        standard,
      },
      () => this.calculatetarifStandardMo()
    );
  }

  changeHourRtmax(_, val) {
    const { rtMax } = this.state;

    rtMax.hourRtmax = val.value;

    this.setState(
      {
        rtMax,
      },
      () => this.calculatetarifRtmaxMo()
    );
  }

  changeHourRtPlus(_, val) {
    const { rtPlus } = this.state;

    rtPlus.hourRtplus = val.value;

    this.setState(
      {
        rtPlus,
      },
      () => this.calculateTarifRtplusMo()
    );
  }

  calculatetarifStandardMo() {
    const {
      standard: {
        tarifMoStandard,
        hourStandard,
      },
      isoValue,
      standard,
    } = this.state;

    standard.prixMoStandardTotal = tarifMoStandard * hourStandard;
    standard.priceMoAumcarré = (tarifMoStandard * hourStandard)
      / isoValue;

    this.setState(
      {
        standard,
      },
      () => {
        this.calculatetarifRtmaxMo();
        this.calculateTarifRtplusMo();
      }
    );
  }

  calculatetarifRtmaxMo() {
    const {
      isoValue,
      rtMax,
      rtMax: {
        tarifMoRtmax,
        hourRtmax,
        rtMaxTotal,
      },
      standard: {
        standardTotal,
        prixMoStandardTotal,
      },
    } = this.state;

    rtMax.prixMoTotal = tarifMoRtmax * hourRtmax;
    rtMax.priceMoAumcarreRtmax = (tarifMoRtmax * hourRtmax)
      / isoValue;
    const reductionRtmax = (standardTotal || 0) + (prixMoStandardTotal || 0);
    const rightSide = (rtMaxTotal || 0) + rtMax.prixMoTotal;
    rtMax.reductionRtmax = ((1 - reductionRtmax / rightSide || 0) * 100).toFixed(2);

    this.setState({
      rtMax,
      reductionRtmax: rtMax.reductionRtmax,
    });
  }

  calculateTarifRtplusMo() {
    const {
      standard: {
        standardTotal,
        prixMoStandardTotal,
      },
      rtPlus,
      rtPlus: {
        tarifMoRtplus,
        hourRtplus,
        rtPlusTotal,
        prixMoTotal,
      },
      isoValue,
    } = this.state;

    rtPlus.prixMoTotal = tarifMoRtplus * hourRtplus;
    rtPlus.priceMoAumcarre = (tarifMoRtplus * hourRtplus)
      / isoValue;
    rtPlus.reductionRtPlus = (standardTotal || 0) + (prixMoStandardTotal || 0);
    const otherSide = (rtPlusTotal || 0) + prixMoTotal;
    rtPlus.reductionRtPlus = ((1 - rtPlus.reductionRtPlus / otherSide || 0) * 100).toFixed(2);

    this.setState({
      rtPlus,
      reductionRtPlus: rtPlus.reductionRtPlus,
    });
  }

  calculateTotalStandard() {
    const { match: { params: { env } } } = this.props;
    const {
      standard,
      standard: {
        entreChevronsItem,
        sousChevronsItem,
        membraneItem,
        suspentesItem,
        solidoubleStandardPrice,
        masticStandardPrice,
        selectedInsulator,
        selectedSupport,
        selectedAdhesif,
        selectedMastic,
        selectedAdhesive,
        selectedMembrane,
      },
      showMonocouche,
      isoValue,
    } = this.state;

    let costsData = [];

    switch (env) {
      case envList.CA.path:
        costsData = [
          {
            type: ProductType.BETWEEN_CHEVRON,
            productData: entreChevronsItem,
          },
          {
            type: ProductType.UNDER_CHEVRON,
            productData: sousChevronsItem,
          },
          {
            type: ProductType.MEMBRANE,
            productData: membraneItem,
          },
          {
            type: ProductType.SHROUD,
            productData: suspentesItem,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.SOLIDOUBLE,
            productData: {
              quantity: Math.ceil((isoValue * 2.35) / 40),
              price: solidoubleStandardPrice,
            },
          },
          {
            type: ProductType.MASTIC,
            productData: {
              quantity: Math.ceil((isoValue * 0.5) / 12),
              price: masticStandardPrice,
            },
          },
        ];
        break;
      case envList.IME.path:
        costsData = [
          {
            type: ProductType.INSULATOR,
            productData: selectedInsulator,
          },
          {
            type: ProductType.SUPPORT,
            productData: selectedSupport,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
        ];
        break;
      case envList.CP.path:
        costsData = [
          {
            type: ProductType.INSULATOR_BETWEEN,
            productData: selectedInsulator,
          },
          {
            type: ProductType.MEMBRANE,
            productData: selectedMembrane,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesive,
          },
          {
            type: ProductType.MASTIC,
            productData: selectedMastic,
          },
        ];
        break;
      default:
        break;
    }

    const costs = StandardService.calculateCost(costsData, isoValue, env);

    switch (env) {
      case envList.CA.path:
        const tarifPerSurface = showMonocouche ? 0 : (
          costs.betweenChevron.tarifPerSurface
        );
        const { tarifOnSurface } = costs.underChevron;
        const { tarifDeSurface } = costs.shroud;
        const tarifMembrane = Number(costs.membrane.tarifMembrane);
        const tarifAdhesif = Number(costs.adhesive.adhesifCost);
        const { tarifSolidouble } = costs.solidouble;
        const tarifMasticRt = Number(costs.mastic.tarifMasticRt);

        // calcul price
        standard.standardTotal = ((!showMonocouche && Number(tarifPerSurface)) || 0)
          + (Number(tarifOnSurface) || 0)
          + (Number(tarifDeSurface) || 0)
          + (Number(tarifMembrane) || 0)
          + (Number(tarifAdhesif) || 0)
          + (Number(tarifSolidouble) || 0)
          + (Number(tarifMasticRt) || 0);
        break;
      case envList.IME.path:
        standard.standardTotal = costs.insulator.insulatorCost
        + costs.support.supportCost
        + costs.adhesive.adhesifCost;
        break;
      case envList.CP.path:
        standard.standardTotal = costs.insulatorBetween.costInsBet
          + costs.membrane.costMem
          + costs.adhesive.adhesifCost
          + costs.mastic.masticCost;
        break;
      default:
        break;
    }

    this.setState({
      standard,
    });
  }

  calculateTotalRtMax() {
    const { match: { params: { env } } } = this.props;
    const {
      rtMax,
      rtMax: {
        entreChevronsItem,
        sousChevronsItem,
        membranesItemRtmax,
        suspentesItem,
        masticPrice,
        selectedInsulator,
        selectedSupport,
        selectedMembrane,
        selectedPastille,
        selectedAdhesif,
        selectedMastic,
        selectedInsulatorSecond,
        selectedAdhesive,
      },
      showMonocouche,
      isoValue,
    } = this.state;

    let costsData = [];

    switch (env) {
      case envList.CA.path: {
        costsData = [
          {
            type: ProductType.BETWEEN_CHEVRON,
            productData: entreChevronsItem,
          },
          {
            type: ProductType.UNDER_CHEVRON,
            productData: sousChevronsItem,
          },
          {
            type: ProductType.MEMBRANE,
            productData: membranesItemRtmax,
          },
          {
            type: ProductType.SHROUD,
            productData: suspentesItem,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.MASTIC,
            productData: {
              quantity: Math.ceil((isoValue * 0.5) / 12),
              price: masticPrice,
            },
          },
        ];

        const costs = RtMaxService.calculateCost(costsData, isoValue, env);

        const tarifPerSurfaceRtmax = showMonocouche ? 0 : (
          costs.betweenChevron.tarifPerSurface
        );
        const tarifOnSurfaceRtmax = (
          costs.underChevron.tarifOnSurface
        );
        const { tarifDeSurface: tarifDeSurfaceRtmax } = costs.shroud;
        const tarifMembraneRtmax = Number(costs.membrane.tarifMembrane);
        const tarifAdhesifRtmax = Number(costs.adhesive.adhesifCost);
        const tarifMasticRtMax = Number(costs.mastic.tarifMasticRt);

        rtMax.rtMaxTotal = ((!showMonocouche && Number(tarifPerSurfaceRtmax)) || 0)
          + (Number(tarifOnSurfaceRtmax) || 0)
          + (Number(tarifDeSurfaceRtmax) || 0)
          + (Number(tarifMembraneRtmax) || 0)
          + (Number(tarifAdhesifRtmax) || 0)
          + (Number(tarifMasticRtMax) || 0);

        break;
      }
      case envList.IME.path: {
        costsData = [
          {
            type: ProductType.INSULATOR,
            productData: selectedInsulator,
          },
          {
            type: ProductType.SUPPORT,
            productData: selectedSupport,
          },
          {
            type: ProductType.MEMBRANE,
            productData: selectedMembrane,
          },
          {
            type: ProductType.PASTILLE,
            productData: selectedPastille,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.MASTIC,
            productData: selectedMastic,
          },
        ];

        const costsIME = RtMaxService.calculateCost(costsData, isoValue, env);

        const {
          support,
          insulator,
          membrane,
          pastille,
          adhesive,
          mastic,
        } = costsIME;

        rtMax.rtMaxTotal = (support.supportCost || 0)
          + (insulator.insulatorCost || 0)
          + (membrane.membraneCost || 0)
          + (pastille.pastilleCost || 0)
          + (adhesive.adhesifCost || 0)
          + (mastic.masticCost || 0);
        break;
      }
      case envList.CP.path: {
        const costData = [
          {
            productData: selectedInsulator,
            type: ProductType.INSULATOR_BETWEEN,
          },
          {
            productData: selectedInsulatorSecond,
            type: ProductType.INSULATOR_SECOND,
          },
          {
            productData: selectedMembrane,
            type: ProductType.MEMBRANE,
          },
          {
            productData: selectedAdhesive,
            type: ProductType.ADHESIVE,
          },
          {
            productData: selectedMastic,
            type: ProductType.MASTIC,
          },
        ];

        const costs = RtMaxService.calculateCost(costData, isoValue, env);

        const {
          insulatorBetween,
          insulatorSecond,
          membrane,
          adhesive,
          mastic,
        } = costs;

        rtMax.rtMaxTotal = (adhesive.adhesifCost || 0)
          + (mastic.masticCost || 0)
          + (membrane.costMem || 0)
          + (insulatorBetween.costInsBet || 0)
          + (insulatorSecond.costSec || 0);

        break;
      }
      default:
        break;
    }


    this.setState(
      {
        rtMax,
      },
      () => this.calculatetarifRtmaxMo()
    );
  }

  calculateTotalRtplus() {
    const { match: { params: { env } } } = this.props;
    const {
      rtPlus,
      rtPlus: {
        entreChevronsItem,
        sousChevronsItem,
        manchonsPrice,
        suspentesItem,
        masticPrice,
        selectedInsulator,
        selectedSupport,
        selectedPastille,
        selectedAdhesif,
        selectedMastic,
        selectedSuspentes,
        selectedAdhesive,
        selectedMembrane,
      },
      showMonocouche,
      isoValue,
    } = this.state;

    switch (env) {
      case envList.CA.path: {
        const costs = RtPlusService.calculateCost([
          {
            type: ProductType.BETWEEN_CHEVRON,
            productData: entreChevronsItem,
          },
          {
            type: ProductType.UNDER_CHEVRON,
            productData: sousChevronsItem,
          },
          {
            type: ProductType.MANCHON,
            productData: {
              quantity: (isoValue * 2.5) / 50,
              price: manchonsPrice,
            },
          },
          {
            type: ProductType.SHROUD,
            productData: suspentesItem,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.MASTIC,
            productData: {
              quantity: Math.ceil((isoValue * 0.5) / 12),
              price: masticPrice,
            },
          },
        ], isoValue);

        const tarifPerSurfaceRtplus = showMonocouche ? 0 : (
          costs.betweenChevron.tarifPerSurface
        ).toFixed(1);
        const tarifOnSurfaceRtplus = (
          costs.underChevron.tarifOnSurface
        ).toFixed(1);
        let tarifDeSurfaceRtplus = 0;
        if (costs && costs.shroud) tarifDeSurfaceRtplus = costs.shroud.tarifDeSurface;
        const { tarifSurfaceManchon } = costs.manchon;
        const tarifAdhesifRtplus = costs.adhesive.adhesifCost;
        const tarifMasticRtplus = Number(
          costs.mastic.tarifMasticRt
        ).toFixed(1);

        rtPlus.rtPlusTotal = (Number(tarifPerSurfaceRtplus) || 0)
          + (Number(tarifOnSurfaceRtplus) || 0)
          + (Number(tarifDeSurfaceRtplus) || 0)
          + (Number(tarifSurfaceManchon) || 0)
          + (Number(tarifAdhesifRtplus) || 0)
          + (Number(tarifMasticRtplus) || 0);

        this.setState(
          {
            rtPlus,
          },
          () => this.calculateTarifRtplusMo()
        );
        break;
      }
      case envList.IME.path: {
        const costsData = [
          {
            type: ProductType.INSULATOR,
            productData: selectedInsulator,
          },
          {
            type: ProductType.SUPPORT,
            productData: selectedSupport,
          },
          {
            type: ProductType.PASTILLE,
            productData: selectedPastille,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.MASTIC,
            productData: selectedMastic,
          },
        ];

        const costsIME = RtMaxService.calculateCost(costsData, isoValue, env);

        const {
          support,
          insulator,
          pastille,
          adhesive,
          mastic,
        } = costsIME;

        rtPlus.rtPlusTotal = (support.supportCost || 0)
          + (insulator.insulatorCost || 0)
          + (pastille.pastilleCost || 0)
          + (adhesive.adhesifCost || 0)
          + (mastic.masticCost || 0);
        break;
      }
      case envList.CP.path: {
        const costsData = [
          {
            type: ProductType.INSULATOR_BLOWN,
            productData: selectedInsulator,
          },
          {
            type: ProductType.MASTIC,
            productData: selectedMastic,
          },
          {
            type: ProductType.SHROUD,
            productData: selectedSuspentes,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesive,
          },
          {
            type: ProductType.MEMBRANE,
            productData: selectedMembrane,
          },
        ];

        const costs = RtPlusService.calculateCost(costsData, isoValue, env);

        rtPlus.rtPlusTotal = costs.adhesive.adhesifCost
          + costs.insulatorBlown.costInsBlown
          + costs.mastic.masticCost
          + costs.membrane.costMem
          + costs.shroud.tarifDeSurface;
        break;
      }
      default:
        break;
    }
  }

  checkConformityCPT() {
    const { match: { params: { env } } } = this.props;

    const {
      standard: {
        entreChevronsItem,
        sousChevronsItem,
      },
      showMonocouche,
    } = this.state;

    const conformity = productInfos[env].haveCpt
      && ((
        entreChevronsItem
        && (entreChevronsItem.cpt === 'OUI' || entreChevronsItem.cpt === '1')
      ) || showMonocouche)
      && (sousChevronsItem && (sousChevronsItem.cpt === 'OUI' || sousChevronsItem.cpt === '1'));

    this.setState({
      conformity,
    });
  }

  handleClickCompare() {
    const { match: { params: { env } }, history } = this.props;
    PDFService.screenPage(PageType.COMPARE).then(() => {
      history.push({
        pathname: `/${env}/standard`,
        state: this.state,
      });
    });
  }

  changeSuspenteRtmax(_, val) {
    const { rtMax } = this.state;
    const suspentesItemRtmax = val.value;
    rtMax.suspentesItem = suspentesItemRtmax;
    rtMax.suspentesPrice = suspentesItemRtmax.price;
    this.setState(
      {
        rtMax,
      },
      () => this.calculateSuspentesRtmax()
    );
  }

  drawImage() {
    const { showMonocouche } = this.state;
    const { match: { params: { env } } } = this.props;
    const { formula, haveCpt } = productInfos[env];

    const columns = Object.values(formula).map((productInfo, index) => {
      let conformity = (
        <Label color="green" className="cptCompare">
          {`Conforme au DTU 45.1${(envList.isCP(env) && index === 2) ? '1' : '0'} : OUI`}
        </Label>
      );

      const {
        [productInfo.conformityKey]: conformityState,
        [productInfo.reductionKey]: reductionState,
      } = this.state;

      if (
        conformityState
        || (envList.isCP(env) && index === 2)
      ) {
        conformity = (
          <Label color="green" className="cptCompare">
            {`Conforme au DTU 45.1${(envList.isCP(env) && index === 2) ? '1' : '0'} : OUI`}
          </Label>
        );
      }

      return (
        <Grid.Column>
          <Segment>
            <div>
              <Image
                src={showMonocouche ? productInfo.img : productInfo.bicoucheImg}
                size="medium"
                className="compareImage"
              />
              {
                productInfo.percent && (
                  <div>
                    <Image src={ribbonOrange} className="percentageRibbon" />
                    <div className="percentageAmount">
                      {`${reductionState}%`}
                    </div>
                  </div>
                )
              }
            </div>
          </Segment>
          {haveCpt && (
            <div>
              { conformity }
              { conformityState && <Icon /> }
            </div>
          )}
        </Grid.Column>
      );
    });
    return (
      <Grid.Row id="compareImagePercentage">
        <Grid.Column computer={5} tablet={3} />
        {columns}
      </Grid.Row>
    );
  }

  render() {
    const { t, history, match: { params: { env } } } = this.props;
    const {
      standard: {
        entreChevronsItem,
        sousChevronsItem,
        tarifMoStandard,
        hourStandard,
        standardTotal,
        prixMoStandardTotal,
        productOptions,
        priceMoAumcarré,
        selectedInsulator,
        insulators,
      },
      rtMax: {
        entreChevrons,
        sousChevrons,
        entreChevronsItem: entreChevronsItemRtmax,
        sousChevronsItem: sousChevronsItemRtmax,
        rtMaxTotal,
        prixMoTotal: prixMoRtmaxTotal,
        tarifMoRtmax,
        hourRtmax,
        priceMoAumcarreRtmax,
        selectedInsulator: selectedInsulatorRtMax,
        insulators: insulatorsRtMax,
      } = {},
      rtPlus: {
        tarifMoRtplus,
        entreChevronsItem: entreChevronsItemRtplus,
        sousChevronsItem: sousChevronsItemRtplus,
        sousChevronsRtplusFiltered,
        entreChevronsRtPlusFiltered,
        hourRtplus,
        prixMoTotal: prixMoRtPlusTotal,
        priceMoAumcarre: priceMoAumcarreRtplus,
        rtPlusTotal,
        selectedInsulator: selectedInsulatorRtplus,
        insulators: insulatorsRtplus,
      },
      isoValue,
      showMonocouche,
      litleScreen,
    } = this.state;
    const jobId = this.getJob();

    return (
      <div>
        <HeaderComponent
          currentPage={2}
          commonState={this.state}
          history={history}
        />
        <Container className="comparePage">
          <Segment className="compareFrame">
            <Container as="h2" className="frameTitle">
              {t(productInfos[env].titleKey)}
            </Container>
            <Grid columns="equal" id="tabContainer">
              <Grid.Row>
                <Grid.Column id="emptyHeader" computer={5} tablet={3} />
                <Grid.Column className="headerCell" id="standardHeader">
                  <Container>
                    <div className="verticallyCentered">
                      {t('compare_title_standard')}
                    </div>
                  </Container>
                </Grid.Column>
                <Grid.Column className="headerCell" id="rtmaxHeader">
                  <Container>
                    <div className="verticallyCentered">
                      {t('compare_title_rtmax')}
                    </div>
                  </Container>
                </Grid.Column>
                <Grid.Column className="headerCell" id="rtplusHeader">
                  <Container>
                    <div className="verticallyCentered">
                      {t('compare_title_rtplus')}
                    </div>
                  </Container>
                </Grid.Column>
              </Grid.Row>
              {!showMonocouche && (
                <Grid.Row>
                  <Grid.Column className="rowHeader" computer={5} tablet={3}>
                    <div className="rowHeaderText">
                      {' '}
                      {t('compare_iso_entre_chevrons')}
                      {' '}
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell standardCell">
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={productOptions}
                      defaultValue={entreChevronsItem}
                      value={entreChevronsItem}
                      onChange={
                        (e, val) => this.changeEntreChevronsStandardCompare(e, val)
                      }
                    />
                  </Grid.Column>
                  <Grid.Column className="tabCell rtmaxCell">
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={entreChevrons}
                      defaultValue={entreChevronsItemRtmax}
                      value={entreChevronsItemRtmax}
                      onChange={(e, val) => this.changeEntreChevronsRtmaxCompare(e, val)
                      }
                    />
                  </Grid.Column>
                  <Grid.Column className="tabCell rtplusCell">
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={entreChevronsRtPlusFiltered}
                      defaultValue={entreChevronsItemRtplus}
                      value={entreChevronsItemRtplus}
                      onChange={(e, val) => this.changeEntreChevronsRtPlusCompare(e, val)
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              )}
              { env !== envList.CP.path && (
                <Grid.Row>
                  <Grid.Column className="rowHeader" computer={5} tablet={3}>
                    <div className="rowHeaderText">
                      {' '}
                      {t(productInfos[env].compareISO)}
                      {' '}
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell standardCell">
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={productOptions || insulators}
                      defaultValue={sousChevronsItem || selectedInsulator}
                      value={sousChevronsItem || selectedInsulator}
                      onChange={(e, val) => this.changeSousChevronsStandardCompare(e, val)
                        }
                    />
                  </Grid.Column>
                  <Grid.Column className="tabCell rtmaxCell">
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={sousChevrons || insulatorsRtMax}
                      defaultValue={sousChevronsItemRtmax || selectedInsulatorRtMax}
                      value={sousChevronsItemRtmax || selectedInsulatorRtMax}
                      onChange={
                        (e, val) => this.changeSousChevronsRtmaxCompare(e, val)
                      }
                    />
                  </Grid.Column>
                  <Grid.Column className="tabCell rtplusCell" column tabCell rtplusCell>
                    <Dropdown
                      className="rowText"
                      search
                      selection
                      disabled
                      options={sousChevronsRtplusFiltered || insulatorsRtplus}
                      defaultValue={sousChevronsItemRtplus || selectedInsulatorRtplus}
                      value={sousChevronsItemRtplus || selectedInsulatorRtplus}
                      onChange={(e, val) => this.changeSousChevronsRtPlusCompare(e, val)
                        }
                    />
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row className="spacer" />
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {
                      litleScreen
                        ? t('compare_tarif_horaire_mo')
                        : `${t('compare_tarif_horaire_mo')} ${t('compare_tarif_horaire_mo_rtmax')}`
                    }
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <Input
                    type="text"
                    value={tarifMoStandard}
                    onChange={(e, val) => this.changeTarifMoStandard(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_tarif_horaire_mo_standard')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <Input
                    type="text"
                    value={tarifMoRtmax}
                    onChange={(e, val) => this.changeTarifMoRtmax(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_tarif_horaire_mo_rtmax')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <Input
                    type="text"
                    value={tarifMoRtplus}
                    onChange={(e, val) => this.changeTarifMoRtPlus(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_tarif_horaire_mo_rtplus')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {t('compare_nombre_dheure')}
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <Input
                    type="text"
                    value={hourStandard}
                    onChange={(e, val) => this.changeHourStandard(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_heure_standard')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <Input
                    type="text"
                    value={hourRtmax}
                    onChange={(e, val) => this.changeHourRtmax(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_heure_rtmax')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <Input
                    type="text"
                    value={hourRtplus}
                    onChange={(e, val) => this.changeHourRtPlus(e, val)}
                    className="tabInput"
                  />
                  {litleScreen
                    && (
                    <div className="rowText">
                      {' '}
                      {t('compare_heure_rtplus')}
                      {' '}
                    </div>
                    )
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="spacer" />
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {t('compare_price_totalmo')}
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil((prixMoStandardTotal || 0).toFixed(2))).toLocaleString()}
                    {' '}
                    {t('compare_price_totalmo_standard')}
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil((prixMoRtmaxTotal || 0).toFixed(2))).toLocaleString()}
                    {' '}
                    {t('compare_price_totalmo_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil((prixMoRtPlusTotal || 0).toFixed(2))).toLocaleString()}
                    {' '}
                    {t('compare_price_totalmo_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {t('compare_price_mo')}
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {' '}
                    {(priceMoAumcarré || 0).toFixed(2)}
                    {' '}
                    {t('compare_price_mo_standard')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {(priceMoAumcarreRtmax || 0).toFixed(2)}
                    {t('compare_price_mo_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {(priceMoAumcarreRtplus || 0).toFixed(2)}
                    {t('compare_price_mo_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="spacer" />
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {t('compare_total_materiaux')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil(Number(standardTotal || 0))).toLocaleString()}
                    {' '}
                    {t('compare_total_materiaux_standard')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil(Number(rtMaxTotal) || 0)).toLocaleString()}
                    {' '}
                    {t('compare_total_materiaux_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {(Math.ceil(Number(rtPlusTotal) || 0)).toLocaleString()}
                    {' '}
                    {t('compare_total_materiaux_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {t('compare_total_mo')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {' '}
                    {((prixMoStandardTotal || 0).toFixed(2))}
                    {' '}
                    {t('compare_total_mo_standard')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {(prixMoRtmaxTotal || 0).toFixed(2)}
                    {' '}
                    {t('compare_total_mo_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {(prixMoRtPlusTotal || 0).toFixed(2)}
                    {' '}
                    {t('compare_total_mo_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="spacer" />
              <Grid.Row className="lastTotals">
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {' '}
                    {
                      jobId === 4
                        ? t('compare_total_facture_particulier')
                        : t('compare_total_facture')}
                    {' '}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {' '}
                    {
                      (
                        Math.ceil(Number(standardTotal || 0) + Number(prixMoStandardTotal || 0))
                      ).toLocaleString()
                    }
                    {' '}
                    {t('compare_total_facture_standard')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {
                      (
                        Math.ceil(Number(rtMaxTotal || 0) + Number(prixMoRtmaxTotal || 0))
                      ).toLocaleString()
                    }
                    {' '}
                    {t('compare_total_facture_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {
                      (
                        Math.ceil(Number(rtPlusTotal || 0) + Number(prixMoRtPlusTotal || 0))
                      ).toLocaleString()
                    }
                    {' '}
                    {t('compare_total_facture_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              { /*  )} */}

              <Grid.Row className="lastTotals">
                <Grid.Column className="rowHeader" computer={5} tablet={3}>
                  <div className="rowHeaderText">
                    {t('total_facture_mcarre')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell standardCell">
                  <div className="rowText">
                    {(
                      ((standardTotal || 0)
                        + (prixMoStandardTotal || 0))
                      / isoValue || 0
                    ).toFixed(2)}
                    {t('total_facture_mcarre_standard')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtmaxCell">
                  <div className="rowText">
                    {' '}
                    {(
                      ((rtMaxTotal || 0)
                        + (prixMoRtmaxTotal || 0))
                      / isoValue || 0
                    ).toFixed(2)}
                    {t('total_facture_mcarre_rtmax')}
                  </div>
                </Grid.Column>
                <Grid.Column className="tabCell rtplusCell">
                  <div className="rowText">
                    {' '}
                    {(
                      ((rtPlusTotal || 0)
                        + (prixMoRtPlusTotal || 0))
                      / isoValue || 0
                    ).toFixed(2)}
                    {t('total_facture_mcarre_rtplus')}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="spacer" />
              {this.drawImage()}
            </Grid>
            <Container
              style={{
                textAlign: 'right',
                marginTop: '55px',
                marginBottom: '25px',
                width: '97%',
              }}
            >
              <Button
                color="green"
                size="big"
                id="btnNext"
                onClick={() => this.handleClickCompare()}
              >
                {t('compare_nextbutton')}
                <Icon name="long arrow alternate right" />
              </Button>
            </Container>
          </Segment>
        </Container>
      </div>
    );
  }
}

CompareComponent.propTypes = {
  match: matchType,
  history: historyType,
  location: locationType,
  t: propTypes.func,
};

export default translate('CompareComponent')(CompareComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/compare/CompareComponent.jsx